<!-- ROLE-SCOPED BACK-OFFICE DROPDOWN -->
<li *ngIf="(isStaff$ | async)" class="nav-item dropdown">
  <a [class]="page == 'Admin' ? 'nav-link dropdown-toggle active' : 'nav-link dropdown-toggle'"
     href="javascript:void(0)" role="button" data-bs-toggle="dropdown">
    {{ menuLabel }}
  </a>

  <ul class="dropdown-menu">
    <ng-container *ngIf="canSupport">
      <li><h6 class="dropdown-header">Support</h6></li>
      <li>
        <a [class]="selectedUrl == '/admin/support' ? 'dropdown-item admin-menu-item active' : 'dropdown-item admin-menu-item'"
           [routerLink]="['/admin/support']">
          <span>Tickets</span>
          <span class="badge rounded-pill" [ngClass]="badgeClass('red')">{{ badgeCounts.tickets }}</span>
        </a>
      </li>
    </ng-container>

    <ng-container *ngIf="canFinance">
      <li *ngIf="canSupport"><hr class="dropdown-divider"></li>
      <li><h6 class="dropdown-header">Financial Configuration</h6></li>
      <li>
        <a class="dropdown-item admin-menu-item" [routerLink]="['/admin/countries']">
          <span>Countries</span>
          <span class="badge rounded-pill" [ngClass]="badgeClass('green')">{{ badgeCounts.countries }}</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item admin-menu-item" [routerLink]="['/admin/currencies']">
          <span>Currencies</span>
          <span class="badge rounded-pill" [ngClass]="badgeClass('green')">{{ badgeCounts.currencies }}</span>
        </a>
      </li>
    </ng-container>

    <ng-container *ngIf="canCompliance">
      <li><hr class="dropdown-divider"></li>
      <li><h6 class="dropdown-header">Compliance</h6></li>
      <li><a class="dropdown-item" [routerLink]="['/admin/compliance']">Dashboard</a></li>
      <li>
        <a class="dropdown-item admin-menu-item" [routerLink]="['/admin/compliance/applications']">
          <span>KYC Reviews</span>
          <span class="badge rounded-pill" [ngClass]="badgeClass('red')">{{ badgeCounts.kycReviews }}</span>
        </a>
      </li>
      <li><a class="dropdown-item" [routerLink]="['/admin/compliance/tiers']">Tier Limits</a></li>
      <li><a class="dropdown-item" [routerLink]="['/admin/country-change-requests']">Country Change Requests</a></li>
      <li><a class="dropdown-item" [routerLink]="['/admin/compliance-flags']">Compliance Flags</a></li>
      <li><a class="dropdown-item" [routerLink]="['/admin/additional-documents']">Additional Documents</a></li>
      <li><a class="dropdown-item" [routerLink]="['/admin/machine-learning/deposit-risk']">Deposit Risk</a></li>
      <li><a class="dropdown-item" [routerLink]="['/admin/machine-learning/withdrawal-risk']">Withdrawal Risk</a></li>
      <li><a class="dropdown-item" [routerLink]="['/admin/machine-learning/predictions']">Risk Predictions</a></li>
      <li><a class="dropdown-item" [routerLink]="['/admin/machine-learning/evaluation']">Risk Evaluation</a></li>
    </ng-container>

    <ng-container *ngIf="canFinance">
      <li><hr class="dropdown-divider"></li>
      <li><h6 class="dropdown-header">Payment Operations</h6></li>
      <li><a class="dropdown-item" [routerLink]="['/admin/payment-gateways/providers']">Payment Providers</a></li>
      <li><a class="dropdown-item" [routerLink]="['/admin/payment-gateways/configs']">Gateway Configs</a></li>
      <li><a class="dropdown-item" [routerLink]="['/admin/payment-gateways/mappings']">Currency Gateway Mappings</a></li>
      <li><a class="dropdown-item" [routerLink]="['/admin/withdrawals/gateways']">Withdrawal Gateways</a></li>
      <li><a class="dropdown-item" [routerLink]="['/admin/withdrawals/fields']">Withdrawal Fields</a></li>
      <li>
        <a class="dropdown-item admin-menu-item" [routerLink]="['/admin/withdrawals/requests']">
          <span>Withdrawal Requests</span>
          <span class="badge rounded-pill" [ngClass]="badgeClass('red')">{{ badgeCounts.withdrawalRequests }}</span>
        </a>
      </li>

      <li><hr class="dropdown-divider"></li>
      <li><h6 class="dropdown-header">Trading & Intelligence</h6></li>
      <li>
        <a class="dropdown-item admin-menu-item" [routerLink]="['/admin/orders']">
          <span>Orders</span>
          <span class="badge rounded-pill" [ngClass]="badgeClass('red')">{{ badgeCounts.orders }}</span>
        </a>
      </li>
      <li><a class="dropdown-item" [routerLink]="['/admin/machine-learning/matching']">Matching Intelligence</a></li>
      <li><a class="dropdown-item" [routerLink]="['/admin/machine-learning/liquidity']">Liquidity Intelligence</a></li>
      <li><a class="dropdown-item" [routerLink]="['/admin/machine-learning/operational-reliability']">Operational Reliability</a></li>
      <li><a class="dropdown-item" [routerLink]="['/admin/machine-learning/withdrawal-risk']">Withdrawal Risk</a></li>
      <li><a class="dropdown-item" [routerLink]="['/admin/machine-learning/predictions']">Operational Predictions</a></li>
      <li><a class="dropdown-item" [routerLink]="['/admin/machine-learning/evaluation']">Model Evaluation</a></li>

      <li><hr class="dropdown-divider"></li>
      <li><h6 class="dropdown-header">Finance & Reporting</h6></li>
      <li *ngIf="canHouseManagement"><a class="dropdown-item" [routerLink]="['/admin/house']">House Management</a></li>
      <li *ngIf="canHouseMarketMaker"><a class="dropdown-item" [routerLink]="['/admin/house/market-maker']">House Market Maker</a></li>
      <li><a class="dropdown-item" [routerLink]="['/admin/finance']">Finance Dashboard</a></li>
      <li><a class="dropdown-item" [routerLink]="['/admin/payment-webhooks']">Payment Webhooks</a></li>
    </ng-container>

    <ng-container *ngIf="isAdmin">
      <li><hr class="dropdown-divider"></li>
      <li><h6 class="dropdown-header">Administration</h6></li>
      <li>
        <a class="dropdown-item admin-menu-item" [routerLink]="['/admin/users']">
          <span>Users & Staff</span>
          <span class="badge rounded-pill" [ngClass]="badgeClass('green')">{{ badgeCounts.users }}</span>
        </a>
      </li>
      <li><a class="dropdown-item" [routerLink]="['/admin/machine-learning']">Machine Learning Control Plane</a></li>
      <li><a class="dropdown-item" [routerLink]="['/admin/settings']">Settings</a></li>
    </ng-container>
  </ul>
</li>
